/* PiFi Community Feedback Survey — wizard controller
   ---------------------------------------------------------------------------
   All screens live in the DOM; this shows one at a time, tracks answers, and
   POSTs once at the end to the Cloudflare Worker.

   Branches (Figma V2):
     issues                → help screen, flow ends there
     Share My experience   → review upload → warranty → gift card → done-review
     Skip                  → warranty (with contact fields) → done-warranty */

(function () {
  'use strict';

  var MAX_UPLOAD = 10 * 1024 * 1024; // keep in step with the Worker

  function init(root) {
    if (root.dataset.pfsReady) return;
    root.dataset.pfsReady = '1';

    var $  = function (sel) { return root.querySelector(sel); };
    var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

    var endpoint = (root.dataset.endpoint || '').replace(/\/$/, '');
    var screens  = $$('.pfs__screen');
    var progress = $('[data-pfs-progress]');
    var percent  = $('[data-pfs-percent]');
    var backBtn  = $('[data-pfs-back]');
    var errorBox = $('[data-pfs-error]');

    var meter = $('.pfs__meter');
    var currentPct = 10;
    var navBottom = 0;   // viewport y of the bottom of the fixed nav

    /* Design-review escape hatch: ?pfs-preview=1 unlocks a screen jumper and
       waives field validation so the later pages can be reached without filling
       the forms. Off for every real visitor. Remove before launch. */
    var previewMode = /[?&]pfs-preview=1\b/.test(location.search);
    var markJumper = null;   // set by buildJumper(); no-op otherwise

    var state = { products: [] };
    var file = null;
    var history = ['welcome'];

    /* ── Header offset ────────────────────────────────────────────────────
       The nav and announcement bar are fixed overlays, so measure whatever is
       actually on screen rather than hardcoding a height. */
    function measureHeader() {
      navBottom = 0;
      ['.pifi-header-wrap', '.announcement-bar', '.shopify-section-header', 'header']
        .forEach(function (sel) {
          document.querySelectorAll(sel).forEach(function (el) {
            var cs = getComputedStyle(el);
            if (cs.position !== 'fixed' && cs.position !== 'sticky') return;
            var r = el.getBoundingClientRect();
            if (r.height) navBottom = Math.max(navBottom, r.bottom + (cs.position === 'sticky' ? window.scrollY : 0));
          });
        });

      // Where this section starts in the document. The theme already offsets
      // <main> to clear the nav, so only the shortfall needs padding — adding
      // the full nav height on top of that is what pushed the form off-screen.
      var offset = Math.round(root.getBoundingClientRect().top + window.scrollY);
      var need = Math.max(0, Math.round(navBottom) - offset);

      root.style.setProperty('--pfs-offset', offset + 'px');
      root.style.setProperty('--pfs-header', need + 'px');
    }

    /* The percentage label sits under the bar and tracks the right edge of the
       fill, as in the Figma frames. Clamped so it never runs past the track. */
    function positionPercent() {
      if (!meter) return;
      var track = meter.getBoundingClientRect().width;
      if (!track) return;
      var labelW = percent.getBoundingClientRect().width || 34;
      var x = Math.min(track * currentPct / 100, track - labelW);
      percent.style.setProperty('--pfs-pct-x', Math.max(0, Math.round(x)) + 'px');
    }

    /* The review CTA belongs to whichever marketplace the buyer named on screen
       2 — sending a Chewy customer to Amazon is worse than sending them
       nowhere, so the button stays hidden until a channel with a review page
       has been chosen. */
    var reviewLink = $('[data-pfs-review-link]');

    function setReviewLink(chip) {
      if (!reviewLink) return;
      var url   = chip && chip.dataset.reviewUrl;
      var label = chip && chip.dataset.value;
      if (url) {
        reviewLink.href = url;
        reviewLink.textContent = 'Review Us on ' + label;
        reviewLink.hidden = false;
      } else {
        reviewLink.removeAttribute('href');
        reviewLink.hidden = true;
      }
    }

    /* ── Navigation ─────────────────────────────────────────────────────── */

    function show(name, skipHistory) {
      var target = screens.filter(function (s) { return s.dataset.screen === name; })[0];
      if (!target) return;

      screens.forEach(function (s) { s.classList.remove('is-active'); });
      target.classList.add('is-active');

      currentPct = parseInt(target.dataset.progress, 10) || 0;
      progress.style.width = currentPct + '%';
      progress.parentNode.setAttribute('aria-valuenow', currentPct);
      percent.textContent = currentPct + '%';
      positionPercent();

      if (!skipHistory && history[history.length - 1] !== name) history.push(name);
      // Nothing to go back to once the response is in: the answers are already
      // sent, so editing them would change nothing and offering the way back
      // only invites a second submission.
      backBtn.hidden = history.length < 2 || target.hasAttribute('data-pfs-final');

      if (markJumper) markJumper(name);

      hideError();
      scrollToStart();
    }

    /* Scroll so the survey's own top bar clears the fixed nav. scrollIntoView
       would put the section flush with the viewport top, i.e. underneath it. */
    function scrollToStart() {
      var top = root.getBoundingClientRect().top + window.scrollY;
      var target = Math.max(0, Math.round(top - navBottom - 12));
      if (Math.abs(window.scrollY - target) > 4) {
        window.scrollTo({ top: target, behavior: 'smooth' });
      }
    }

    function progressOf(name) {
      var s = screens.filter(function (x) { return x.dataset.screen === name; })[0];
      return s ? parseInt(s.dataset.progress, 10) || 0 : 0;
    }

    /* Back must never move forward through the survey. Walking the history
       stack blindly did: the stack picks up duplicates whenever a branch is
       revisited, so popping one entry could land on a screen further along than
       the current one. Popping until the candidate is genuinely earlier makes
       that impossible whatever state the stack is in. */
    function goBack() {
      if (history.length < 2) return;
      var current = progressOf(history[history.length - 1]);

      while (history.length > 1) {
        history.pop();
        var candidate = history[history.length - 1];
        if (progressOf(candidate) < current) { show(candidate, true); return; }
      }
      show(history[0], true);
    }

    /* Tokens starting with "_" are branch points rather than screen names. */
    function resolve(token) {
      if (token === '_experience') {
        return state.experience === 'issues' ? 'help' : 'share';
      }
      if (token === '_warranty') {
        return state.sharedReview ? 'giftcard' : '_submitWarranty';
      }
      return token;
    }

    /* ── Errors ─────────────────────────────────────────────────────────── */

    function showError(msg) { errorBox.textContent = msg; errorBox.hidden = false; }
    function hideError() { errorBox.hidden = true; errorBox.textContent = ''; }

    /* ── Validation ─────────────────────────────────────────────────────── */

    function isEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

    /* Clear the red underline as soon as the field is touched. It was only ever
       toggled inside validate(), which runs on Next/Submit — so a field stayed
       marked after the visitor had already corrected it, which reads as the
       form still rejecting perfectly good input. */
    $$('[data-pfs-input]').forEach(function (input) {
      input.addEventListener('input', function () {
        if (input.classList.contains('is-invalid')) {
          input.classList.remove('is-invalid');
          hideError();
        }
      });
    });

    function markInvalid(input, bad) {
      if (input) input.classList.toggle('is-invalid', !!bad);
    }

    function validate(groups, screen) {
      var ok = true;
      // Tracked apart from `ok` so a missing upload — which has no field to
      // turn red — can say what it wants instead of the generic message.
      var otherBad = false;
      var wants = (groups || '').split(',').filter(Boolean);

      wants.forEach(function (g) {
        if (g === 'name' || g === 'contact') {
          var nameInput = screen.querySelector('[data-pfs-input="name"]');
          if (nameInput && nameInput.offsetParent !== null) {
            var bad = !nameInput.value.trim();
            markInvalid(nameInput, bad);
            if (bad) { ok = false; otherBad = true; }
          }
        }
        if (g === 'email' || g === 'contact') {
          var mail = screen.querySelector('[data-pfs-input="email"]');
          if (mail && mail.offsetParent !== null) {
            var badMail = !isEmail(mail.value.trim());
            markInvalid(mail, badMail);
            if (badMail) { ok = false; otherBad = true; }
          }
        }
        if (g === 'products') {
          var none = !screen.querySelectorAll('[data-pfs-product]:checked').length;
          // The other required fields turn red; this group silently refused,
          // leaving nothing to point at what was missing.
          var legend = screen.querySelector('.pfs__fieldset legend');
          if (legend) legend.classList.toggle('is-invalid', none);
          if (none) { ok = false; otherBad = true; }
        }
        if (g === 'serial') {
          var wrap = screen.querySelector('[data-pfs-serial]');
          if (wrap && !wrap.hidden) {
            var serial = wrap.querySelector('input');
            var badSerial = !serial.value.trim();
            markInvalid(serial, badSerial);
            if (badSerial) { ok = false; otherBad = true; }
          }
        }
        if (g === 'screenshot') {
          // The reward is paid against a published review, so the screenshot
          // is the evidence — not an optional extra. Skip remains the way out
          // for anyone who does not want the gift card.
          var zone = screen.querySelector('[data-pfs-dropzone]');
          var noFile = !file;
          if (zone) zone.classList.toggle('is-invalid', noFile);
          if (noFile) ok = false;
        }
      });

      if (!ok) {
        showError(otherBad
          ? 'Please complete the required fields before continuing.'
          : 'Please upload your review confirmation to continue.');
      }
      return ok;
    }

    /* ── Collect answers ────────────────────────────────────────────────── */

    function collect() {
      $$('[data-pfs-input]').forEach(function (el) {
        if (el.offsetParent === null) return;      // ignore hidden variants
        // Assign even when empty. Skipping blanks meant that clearing a field
        // you had already filled left the old value in state, and we would go
        // on to submit an address the visitor had deliberately deleted.
        state[el.dataset.pfsInput] = el.value.trim();
      });
      state.products = $$('[data-pfs-product]:checked').map(function (el) { return el.value; });

      // A hidden serial field means "not applicable", not "keep the old one":
      // check the feeder, type a serial, then uncheck it, and the stale number
      // would otherwise ride along on a submission for other products. This is
      // the opposite of the contact fields, whose hidden state means "already
      // captured on the review screen" and must survive.
      var serialWrap = $('[data-pfs-serial]');
      if (serialWrap && serialWrap.hidden) delete state.serialNumber;

      return state;
    }

    /* ── Submit ─────────────────────────────────────────────────────────── */

    /* One response per visit. The button used to be re-enabled unconditionally
       once the request settled, so anyone who went Back from the thank-you
       screen could send the whole thing a second time — a duplicate email and a
       duplicate record, with nothing to tell the two apart. */
    var submitted = false;

    function submit(btn, doneScreen) {
      if (submitted) { show(doneScreen); return; }
      if (!endpoint) { showError('Form endpoint is not configured.'); return; }
      collect();

      var honeypot = $('[data-pfs-honeypot]');
      var fd = new FormData();
      // The jumper skips validation, so a preview run can submit answers a
      // real visitor could never produce. Say so, rather than letting the
      // result sit in the admin looking like a genuine response.
      if (previewMode) state.previewMode = true;
      fd.append('answers', JSON.stringify(state));
      if (file) fd.append('screenshot', file);
      if (honeypot && honeypot.value) fd.append('website', honeypot.value);

      if (btn) { btn.classList.add('is-busy'); btn.disabled = true; }
      hideError();

      fetch(endpoint + '/survey', { method: 'POST', body: fd })
        .then(function (r) { return r.json().catch(function () { return { ok: false }; }); })
        .then(function (data) {
          if (data && data.ok) {
            submitted = true;
            show(doneScreen);
          } else {
            showError('Sorry — we could not submit your response. Please try again.');
          }
        })
        .catch(function () {
          showError('Network error. Please check your connection and try again.');
        })
        .finally(function () {
          // Only hand the button back if the response did not land, so a
          // failure can be retried but a success cannot be repeated.
          if (btn && !submitted) { btn.classList.remove('is-busy'); btn.disabled = false; }
        });
    }

    /* ── Wiring ─────────────────────────────────────────────────────────── */

    backBtn.addEventListener('click', goBack);

    // Single-select choice groups
    $$('[data-pfs-choice]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.dataset.pfsChoice;
        var screen = btn.closest('.pfs__screen');
        screen.querySelectorAll('[data-pfs-choice="' + group + '"]').forEach(function (b) {
          b.setAttribute('aria-checked', String(b === btn));
        });
        state[group] = btn.dataset.value;
        if (group === 'channel') setReviewLink(btn);

        var cta = screen.querySelector('[data-pfs-next], [data-pfs-submit]');
        if (cta) cta.disabled = false;
        hideError();
      });
    });

    // Serial number field appears only for products that need one
    $$('[data-pfs-product]').forEach(function (cb) {
      cb.addEventListener('change', function () {
        var screen = cb.closest('.pfs__screen');
        var wrap = screen.querySelector('[data-pfs-serial]');
        if (!wrap) return;
        var needed = Array.prototype.some.call(
          screen.querySelectorAll('[data-pfs-product]:checked'),
          function (el) { return el.hasAttribute('data-needs-serial'); }
        );
        wrap.hidden = !needed;
        var legend = screen.querySelector('.pfs__fieldset legend');
        if (legend) legend.classList.remove('is-invalid');
        hideError();
      });
    });

    // Advance buttons
    $$('[data-pfs-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var screen = btn.closest('.pfs__screen');

        if (!previewMode && btn.dataset.pfsValidate && !validate(btn.dataset.pfsValidate, screen)) return;

        // data-pfs-set="key:value" — record a flag before moving on
        if (btn.dataset.pfsSet) {
          btn.dataset.pfsSet.split(',').forEach(function (pair) {
            var kv = pair.split(':');
            state[kv[0]] = kv[1] === 'true' ? true : kv[1] === 'false' ? false : kv[1];
          });
        }

        collect();

        /* data-pfs-forget="a,b" — drop these answers. Named apart from the
           upload widget's own data-pfs-clear, which marks the Remove button:
           sharing the name made querySelector return whichever came first in
           the document, and Remove stopped appearing. Skipping the review is
           an explicit "I don't want to share", so anything typed on that screen
           before changing course should not follow the visitor forward: had
           they meant to use it they would have submitted that screen instead of
           coming back to Skip. Runs after collect() so it wins. */
        if (btn.dataset.pfsForget) {
          btn.dataset.pfsForget.split(',').forEach(function (key) {
            key = key.trim();
            // The screenshot lives outside state, so it needs its own reset —
            // otherwise an image chosen before changing course would still be
            // attached to a warranty-only submission.
            if (key === 'screenshot') { resetUpload(); return; }
            delete state[key];
          });
        }

        var next = resolve(btn.dataset.pfsNext);

        if (next === '_submitWarranty') { submit(btn, 'done-warranty'); return; }

        // Reveal contact fields on the warranty form when they weren't captured
        if (next === 'warranty-form') {
          var needContact = !state.email;
          root.querySelectorAll('[data-pfs-contact]').forEach(function (el) { el.hidden = !needContact; });
        }

        show(next);
      });
    });

    // Final submit (gift card screen)
    var submitBtn = $('[data-pfs-submit]');
    if (submitBtn) {
      submitBtn.addEventListener('click', function () { submit(submitBtn, 'done-review'); });
    }

    /* ── Upload ─────────────────────────────────────────────────────────── */

    var fileInput = $('[data-pfs-file]');
    var dropzone  = $('[data-pfs-dropzone]');
    var preview   = $('[data-pfs-preview]');
    var clearBtn  = $('[data-pfs-clear]');

    function resetUpload() {
      file = null;
      if (fileInput) fileInput.value = '';
      if (!preview) return;
      if (preview.src) URL.revokeObjectURL(preview.src);
      preview.hidden = true;
      preview.removeAttribute('src');
      dropzone.hidden = false;
      dropzone.classList.remove('is-invalid');
      clearBtn.hidden = true;
    }

    function acceptFile(f) {
      if (!f) return;
      if (!/^image\//.test(f.type)) { showError('Please upload an image file.'); return; }
      if (f.size > MAX_UPLOAD) { showError('That image is larger than 10MB. Please upload a smaller file.'); return; }
      file = f;
      if (preview.src) URL.revokeObjectURL(preview.src);
      preview.src = URL.createObjectURL(f);
      preview.hidden = false;
      dropzone.hidden = true;
      dropzone.classList.remove('is-invalid');
      clearBtn.hidden = false;
      hideError();
    }

    if (fileInput) {
      fileInput.addEventListener('change', function () { acceptFile(fileInput.files[0]); });
    }

    if (dropzone) {
      ['dragenter', 'dragover'].forEach(function (ev) {
        dropzone.addEventListener(ev, function (e) {
          e.preventDefault();
          dropzone.classList.add('is-drag');
        });
      });
      ['dragleave', 'drop'].forEach(function (ev) {
        dropzone.addEventListener(ev, function (e) {
          e.preventDefault();
          dropzone.classList.remove('is-drag');
        });
      });
      dropzone.addEventListener('drop', function (e) {
        if (e.dataTransfer && e.dataTransfer.files) acceptFile(e.dataTransfer.files[0]);
      });
    }

    if (clearBtn) clearBtn.addEventListener('click', resetUpload);

    /* ── Screen jumper (design review only) ───────────────────────────────
       Delete this function and the .pfs__dev rules in the stylesheet before
       launch; nothing else references either. */
    function buildJumper() {
      var bar = document.createElement('nav');
      bar.className = 'pfs__dev';
      bar.setAttribute('aria-label', 'Screen jumper (preview only)');
      bar.innerHTML = '<b>Preview</b>';

      screens.forEach(function (s) {
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = s.dataset.screen;
        b.addEventListener('click', function () {
          // Warranty contact fields are normally revealed by the flow that
          // reaches them; jumping straight in would leave them hidden.
          root.querySelectorAll('[data-pfs-contact]').forEach(function (el) { el.hidden = false; });
          // Reset rather than append: pushing jumps onto the stack made Back
          // retrace the order they were clicked in, which ran forwards through
          // the survey as often as backwards.
          history.length = 0;
          show(s.dataset.screen, true);
          history.push(s.dataset.screen);
          backBtn.hidden = true;
        });
        bar.appendChild(b);
      });

      document.body.appendChild(bar);

      // show() owns the highlight, so it tracks the form's own Next/Back too,
      // not just clicks in here.
      markJumper = function (name) {
        bar.querySelectorAll('button').forEach(function (x) {
          x.classList.toggle('is-on', x.textContent === name);
        });
      };
      markJumper(screens.filter(function (s) {
        return s.classList.contains('is-active');
      }).map(function (s) { return s.dataset.screen; })[0] || '');
    }

    /* ── Boot ───────────────────────────────────────────────────────────── */

    measureHeader();
    window.addEventListener('resize', function () {
      measureHeader();
      positionPercent();
    }, { passive: true });
    setTimeout(function () { measureHeader(); positionPercent(); }, 400);

    show('welcome', true);
    backBtn.hidden = true;

    if (previewMode) buildJumper();
  }

  function boot() { document.querySelectorAll('.pfs').forEach(init); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor re-renders sections without a page load
  document.addEventListener('shopify:section:load', boot);
})();
